// extracted by mini-css-extract-plugin
export var cardContainer = "_o5-0";
export var cardHeader = "_o5-2";
export var collapsedState = "_o5-3";
export var dragHandle = "_o5-5";
export var dragHandleIcon = "_o5-6";
export var dragging = "_o5-1";
export var titleArea = "_o5-4";